import { useGetReports } from 'hooks/useGetReports';
import ReportDashboard from './ReportDashboard';

export const ReportsTemplate = () => {
  const { data, isLoading } = useGetReports();

  if (isLoading) {
    return <></>;
  }

  if (!data) {
    return <>No Data to report.</>;
  }
  return (
    <>
      <ReportDashboard data={data?.data.report} meta={data?.data.meta} />
    </>
  );
};
